import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogClose } from "@angular/material/dialog";
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: 'app-iackathon-preview-zoom-dialog',
    imports: [
        MatDialogClose,
        MatIconModule,
        MatTooltipModule,
        TranslateModule,
    ],
  templateUrl: './iackathon-preview-zoom-dialog.component.html',
  styleUrl: './iackathon-preview-zoom-dialog.component.scss',
})
export class IackathonPreviewZoomDialogComponent {
    public data = inject(MAT_DIALOG_DATA);
    public path = this.data.path
}
